var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgParent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 62.212,
    height: 40,
    viewBox: "0 0 62.212 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_78",
    "data-name": "Group 78",
    transform: "translate(-1793.917 -388.574)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_107",
    "data-name": "Path 107",
    d: "M269.9,368.129a11.08,11.08,0,1,0-12.717,0,19.4,19.4,0,0,0-13.013,18.295,1.552,1.552,0,0,0,3.1,0,16.278,16.278,0,1,1,32.557,0,1.552,1.552,0,0,0,3.1,0C282.936,377.433,275.059,369.931,269.9,368.129Zm-14.336-9.062a7.983,7.983,0,1,1,7.987,7.983,7.983,7.983,0,0,1-7.987-7.983Z",
    transform: "translate(1549.747 40.599)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_107-2",
    "data-name": "Path 107",
    d: "M261.48,361.534a7.454,7.454,0,1,0-8.556,0,13.055,13.055,0,0,0-8.754,12.308,1.044,1.044,0,0,0,2.089,0,10.951,10.951,0,1,1,21.9,0,1.044,1.044,0,0,0,2.089,0C270.25,367.793,264.951,362.746,261.48,361.534Zm-9.644-6.1a5.371,5.371,0,1,1,5.373,5.37,5.37,5.37,0,0,1-5.373-5.37Z",
    transform: "translate(1585.878 53.688)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgParent);
export default __webpack_public_path__ + "static/media/parent.2267566dab981cb7b03bde8e9c714aae.svg";
export { ForwardRef as ReactComponent };